import { render, staticRenderFns } from "./StockAddNew.vue?vue&type=template&id=13269193&scoped=true&"
import script from "./StockAddNew.vue?vue&type=script&lang=js&"
export * from "./StockAddNew.vue?vue&type=script&lang=js&"
import style0 from "./StockAddNew.vue?vue&type=style&index=0&id=13269193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13269193",
  null
  
)

export default component.exports